import configs from 'config';
import { message } from 'antd';
import { STATUS_REMOVE_ACCOUNT } from 'common';
import { isNumber } from 'lodash';

export const handleErrorMessage = (error: any) => {
  message.destroy();
  if (error?.display && typeof(error.message) === 'string') {
    message.error(error.message);
  } else {
    message.error(getErrorMessage(error));
  }
  if (configs.APP_ENV !== 'prod') {
    // tslint:disable-next-line: no-console
    console.log(error);
  }
};

export const convertUnitPrice = (unitPrice: any) => {
  if (!unitPrice) return 0;
  if (isNumber(unitPrice)) return unitPrice;
  return Number(unitPrice?.replaceAll(',', '') || 0);
};

export const getErrorMessage = (error: any) => {
  if (typeof error === 'string' && error.trim()) return error;
  return error?.response?.data?.errorMessage || error?.message || 'Something went wrong!';
};
